import { Alert, Button, Modal } from '@payaca/ambrosia';
import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';

export type ConfirmDeleteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  entityName: {
    singular: string;
    plural: string;
  };
  destructiveVerb?: 'delete' | 'remove' | 'archive';
  isBusy?: Nullish<boolean>;
  errorMessage?: Nullish<string>;
  numSelected?: Nullish<number>;
};

const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = (props) => {
  const {
    isOpen,
    onClose,
    onConfirmDelete,
    entityName,
    destructiveVerb = 'delete',
    isBusy,
    errorMessage,
    numSelected,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${destructiveVerb.charAt(0).toUpperCase() + destructiveVerb.slice(1)} ${entityName.singular}`}
    >
      <Modal.Body>
        <p>
          Are you sure you want to {destructiveVerb}{' '}
          {(numSelected ?? 1) === 1
            ? `this ${entityName.singular}`
            : `the selected ${entityName.plural}`}
          ?
        </p>
        {errorMessage && (
          <Alert colour="red" className="mt-4">
            {errorMessage}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            variant="outline"
            onClick={onClose}
            disabled={Boolean(isBusy)}
          >
            No, cancel
          </Button>
          <Button
            colour="red"
            onClick={onConfirmDelete}
            isProcessing={Boolean(isBusy)}
          >
            Yes, {destructiveVerb}
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
